import {accountType$} from "./state";

const React = require('react');
import {
  PERMISSION_EDIT_BANK_DETAILS,
} from '../../../../../../../constants/permissions';
import {
  isUserAccessed,
} from '../../../../../../../emitters/account';
import {MerchantSelect} from "../../../../../../helpers/InputsHelpers";
const Button = require('../../../../../../dumb/Button/C');
const {
  bankAccountId$,
} = require('./state');
const accountTypes = require('./constants/accountType');
const withState = require('../../../../../../../utils/withState');


module.exports = withState((setState) => {
  return (state, props) => {
    const disabled = !isUserAccessed(PERMISSION_EDIT_BANK_DETAILS);

    const activeTab = state.accountType || 'bankAccounts';
    const ActiveComponent = (accountTypes.find((el) => el.id === activeTab)|| {}).listComponent;

    return (
      <div className={props.className || ''}>
        <div className="layoutRow fhaB fvaC mt30">
          <div className="layoutRow fhaB fvaC">
            <div className="w200">
              <MerchantSelect
                // className="f12 lh17 fw7 w225"
                propName="title"
                propValue="id"
                value={activeTab}
                items={accountTypes}
                onChange={(_, activeTab) => {
                  accountType$.emit(activeTab);
                }}
              />
            </div>
          </div>
          <Button
            className="w170 mv-5"
            disabled={disabled}
            onClick={() => {
              bankAccountId$.emit('create');
              accountType$.emit(activeTab);
            }}
          >
            New account
          </Button>
        </div>
        {ActiveComponent
          ? (
            <ActiveComponent
              className="mt35"
              disabled={disabled}
            />
          ) : <span />
        }
        {/*<BankAccounts*/}
        {/*  className="mt35"*/}
        {/*  disabled={disabled}*/}
        {/*/>*/}
      </div>
    );
  }
}, {
  accountType: accountType$
});
